<template>
  <div class='warpper'>
    <div class='gameList'>
      <div class='list' v-for='(item,index) in itemList' :key='index'>
        <div class='item' @click='play(index)'>
          <div class='picture'>
            <img :src='item.picture' width='120px' height='120px' :title='item.keyid'>
          </div>

          <div class='title'>
            <p>{{item.chinese}}</p>
            <p>{{item.english}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MiniList',
  data () {
    return {
      itemList: [{
        id: 1,
        keyid: 'liferemaker',
        chinese: '人生重开模拟器',
        english: 'Life Remaker',
        picture: require('../../../assets/images/list-liferemaker.png'),
        route: 'liferemaker',
      }, {
        id: 2,
        keyid: 'cybermerit',
        chinese: '赛博木鱼',
        english: 'Cyber Merit',
        picture: require('../../../assets/images/list-cybermerit.png'),
        route: 'cybermerit',
      }]
    }
  },
  methods: {
    play (index) {
      this.$bus.$emit('playContent', this.itemList[index].route)
    }
  }
}
</script>

<style scoped>
.warpper {
  text-align: center;
}
.gameList {
  display: inline;
}
.list {
  padding: 30px 0 0 0;
}
.item {
  display: inline-block;
  width: 400px;
  height: 180px;
  background-color: rgb(240, 181, 181);
  margin: 0 0 40px 0;
  cursor: pointer;
  align-items: center;
}
.item .picture {
  float: left;
  margin: 30px 30px 30px 20px;
  width: 120px;
  height: 120px;
  border: 1px solid black;
}
.item .title {
  /* text-align: left; */
  display: flex;
  flex-direction: column;
  margin: auto;
  justify-content: space-evenly;
  font-size: 25px;
  font-weight: bolder;
  height: 100%;
}
</style>